import Logo from "../assets/img/Logo_launch_capital.svg";
import Poweredby from "../assets/img/BackrrFullGrey.png";
import favicon from "../assets/img/Launch-capital-favicon.png";

const Initial = {
  branding: {
    favicon:favicon,
    logo: Logo,
    poweredbylogo: Poweredby,
  },
  organization:{
    title:"LCAF: Submit Startup Application",
    description:"Fill this form if you are one of the founders / co-founders of the startup",
  },
  theme: {
    mainColor:"#f7aa1d",    //set the button color 
    headerColor:"#21386C",    //set the header color of the table 
  },
  api:{
    baseUrl:""
  }
};

// Inject CSS variables directly into the document head
const setCSSVariables = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    :root {
      --main-color: ${Initial.theme.mainColor};
      --header-color: ${Initial.theme.headerColor};
    }
  `;
  document.head.appendChild(style);
};

// Call the function to apply styles
setCSSVariables();
window.Initial = Initial;

export default Initial;
